import React, { useState, useEffect } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import Collapse from '@material-ui/core/Collapse';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import SettingsIcon from '@material-ui/icons/Settings';
import Toolbar from '@material-ui/core/Toolbar';
import classNames from 'classnames';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import AccountBoxRoundedIcon from '@material-ui/icons/AccountBoxRounded';
import { TransportBookThumbnail, TransportBookContact } from '../../../components/icons'
import { RechargeFastag } from '../TopCard/icons';
import RechargeFastagSideBar from '../RightSideBar/RechargeFastagSideBar';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import * as logger from "../../../logger";
import DriverNameSelect from '../../components/DriverDialogs/DriverNameSelect';
import DriverGaveAndGot from '../../components/DriverDialogs/DriverGaveAndGot';
import AddDialog from '../../components/AddDialogComponent/AddDialogComponent';
import AddParty from '../../pages/Parties/AddParty';
import AddVehicle from '../../pages/Vehicles/AddVehicle';
import AddShop from '../../pages/Shops/AddShop';
import ShopCreditAndPayment from '../Shops/ShopCreditAndPayment';
import {
  getPartyLedgerData,
  getSinglePartyLedgerData,
  getSinglePartyLedgerDataV2,
  getTripLedgerData,
  getTripLedgerDataV2,
  getVendorLedgerData,
  getSingleVendorLedgerData,
  getSparklineTotalBalances
} from "../../../store/actions/homeActionCreator";
import {
  getTripDetailsV3,
  deleteTrip,
  getInvoiceList,
  toggleEditInvoiceFlag,
  getSingleInvoice,
  getJourneyDetails
} from "../../../store/actions/tripActionCreator";
import {
  updateChatView, getMultiUserList, fetchSupplierTransactionLog
} from "../../../store/actions/userActionCreators";
import { fetchSingleDriver, deleteDriver, editDriver, getVehicleLedgerData, singleVendorDetails, PandL, Expenses, singleTruck } from '../../../store/actions/vehicleActionCreator';
import { getTripSparkLine, getPartyPayments, getMonthlyBalancesParty, getPartyDetails } from '../../../store/actions/partiesActionCreator';
import {
  TRIP_TRANSACTION_FILTER,
  TRIP_FILTER_STATUS_MAPPING
} from "../../../store/constants";
import RemoveIcon from '@material-ui/icons/Remove';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import headerStyles from '../css/header';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuList from '@material-ui/core/MenuList';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Form } from 'react-final-form';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Autocomplete,
  Switches
} from 'mui-rff';
import InputAdornment from '@material-ui/core/InputAdornment';
import NotesIcon from '@material-ui/icons/Notes';
import Divider from '@material-ui/core/Divider';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import Switch from '@material-ui/core/Switch';
import { withStyles } from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import EditProfileDialog from '../EditProfileDialog/editProfileDialog';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteTrip from '../../components/Trip/DeleteTrip'
import DeleteTripJourney from '../../components/Trip/DeleteTripJourney';
import { getUserDetails, toggleOverlay } from '../../../store/actions/authActionCreators';
import {
  getSingleFastTagDetails,
  getFastTagRechargeStatus,
  getWalletBalance
} from "../../../store/actions/fastagActionCreators";
import AddEditTripSideBar from '../Trip/AddEditTripSideBar';
import DeletePartyDialog from '../Dialog/DeletePartyDialog';
import AddSupplier from '../../pages/Suppliers/AddSupplier';
import DeleteSupplierDialog from '../Dialog/DeleteSupplierDialog';
import DeleteShopDialog from '../Dialog/DeleteShopDialog';
import ComingSoonModal from '../../components/ComingSoonModal/comingSoonModal';
import { trackDwebEvent } from '../../analytics';
import CloseIcon from '@material-ui/icons/Close';
import { numberFormat, findArrayObject, getTripStartDateFilterValues, checkNumberOnly, numberWithCommas, replaceCommas, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis, getTripDateFilterValues, getMilliDatePickerDateInStringDDMMMYYYY } from "../../../utils/utils";
import TripCompleteActionDialog from '../Trip/TripCompleteActionDialog';
import AddExpenseSelectionDialog from '../VehicleDialogs/AddExpenseSelectionDialog';
import { sendSucces, sendError } from "../../../utils/utils";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AccountDetailsDialog from '../AccountDetails/AccountDetails';
import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import MuiltiUserAddUserDialog from '../Dialog/MultiUserAddUser';
import MultiUserInviteSuccess from '../Dialog/MultiUserInviteSuccessDialog';
import { Page } from 'react-pdf';
import AddPaymentSingleParty from '../Party/AddPartyPayment';
import AddPaymentSingleSupplier from '../Supplier/AddPaymentSingleSupplier';
import { defaultPageNo, defaultPageSize } from '../../../paginationVariables';
import AddInvoiceSideBar from '../RightSideBar/AddInvoiceSideBar/AddInvoiceSideBar';
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined';
import DoneIcon from '@material-ui/icons/Done';
import DeleteInvoiceDialog from '../Dialog/DeleteInvoiceDialog';
import ReportsDialog from '../ReportsDialog/ReportsDialog';
import InvoiceAddPaymentSideBar from '../InvoiceSidebarAndDialog/InvoiceAddPayment';
import SupplierPassbookPopUp from '../Supplier/SupplierPassbookPopUp';
import EditDriverDialog from '../Dialog/EditDriverDialog';
import moment from 'moment';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import AddEditOpeningBalanceParty from '../../pages/Parties/AddEditOpeningBalanceParty';
import EditLoadDetailsSideBar from '../RightSideBar/EditLoadDetailsSideBar';
import HelpIcon from '@material-ui/icons/Help';
import DieselCardRechargeSideBar from "../RightSideBar/DieselCardSideBar/RechargeSideBar";
import { PremiumMenuIcon } from '../../../components/icons';
const SendSmsSwitch = withStyles({
  switchBase: {
    color: "#E8E8E8",
    '&$checked': {
      color: "#0033cc",
    },
    '&$checked + $track': {
      backgroundColor: "#0033cc",
    },
  },
  checked: {},
  track: {
    backgroundColor: "#D8D8D8"
  },
})(Switch);

const Header = ({
  dispatchGetSingleFastagVehicleDetails,
  logo,
  logoAltText,
  toggleFullscreen,
  toggleDrawer,
  toggleNotifications,
  userDetails,
  user,
  trip,
  location,
  dispatchLogoutAction,
  vehicle,
  dispatchGetPartyLedgerAction,
  dispatchGetSingleDriver,
  dispatchFetchUserDetails,
  dispatchDeleteDriver,
  dispatchEditDriver,
  dispatchTripDetailsAction,
  dispatchGetTripLedgerAction,
  dispatchGetSingleVendorDetails,
  dispatchGetVendorLedgerAction,
  dispatchGetSingleTruck,
  dispatchGetPandL,
  dispatchGetTripExpenses,
  //tripDetails,
  dispatchGetVehicleLedgerAction,
  dispatchGetSinglePartyTripSparkLine,
  dispatchGetSinglePartyPayments,
  parties,
  dispatchGetSinglePartyLedgerAction,
  dispatchGetSinglePartyMonthlyBalancesAction,
  dispatchChatView,
  payments,
  dispatchToggleTripOverlay,
  dispatchGetMultiUserList,
  dispatchGetSingleVendorLedger,
  dispatchFetchSupplierTransact,
  dispatchEditInvoiceFlag,
  dispatchGetSingleInvoice,
  dispatchGetSparklineBalances,
  dispatchGetWalletBalance,
  dispatchGetPartyDetails,
}) => {

  let submit;
  const [addVehicleOpen, toggleAddVehicleOpen] = React.useState(false);
  const [fastagRechargeOpen, setFastagRechargeOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [driverNameModalOpen, setDriverNameModalOpen] = useState(false);
  const [addDriverModalOpen, setDriverModalOpen] = useState(false);
  const [addPartyOpen, setAddPartyOpen] = useState(false);
  const [addShopOpen, setAddShopOpen] = useState(false);
  const [editPartyDialogOpen, setEditPartyDialogOpen] = useState(false);
  const [deletePartyDialogOpen, setDeletePartyDialogOpen] = useState(false);
  const [addSupplier, setAddSupplier] = useState(false);
  const [isTourOpen, setIsTourOpen] = useState(false);

  const partyLedgerRequestData = {
    fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
    pageNo: defaultPageNo,
    pageSize: defaultPageSize,
  };
  const [type, setType] = useState("");
  const [dialogGaveAndGot, setDialogGaveAndGot] = useState(false);
  const [dialogShopCreditPayment, setDialogShopCreditPayment] = useState(false);
  const [moreMenu, setMoreMenu] = useState(false);
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [editDriverDialog, setEditDriverDialog] = useState(false);
  const [driverSendSms, setDriverSendSms] = useState(false);
  const [editProfileModal, setEditProfileModal] = useState(false);
  const [deleteTripOpen, setDeleteTripOpen] = useState(false);
  const [addEditTripSideBarOpen, setAddEditTripSideBarOpen] = useState(false);
  const [addPartyPaymentOpen, setAddPartyPaymentOpen] = useState(false);
  const [comingSoonModal, setComingSoonModal] = useState(false);
  const [featureNameValue, setFeatureNameValue] = useState("");
  const [completeTripOpen, setCompleteTripOpen] = useState(false);
  const [addExpenseDialog, setAddExpenseDialog] = useState(false);
  const [addInvoiceFlag, setAddInvoiceFlag] = useState(false);

  const [openSupplier, setOpenSupplier] = useState(false);
  const [editSupplierDialogOpen, setEditSupplierDialogOpen] = useState(false);
  const [deleteSupplierDialogOpen, setDeleteSupplierDialogOpen] = useState(false);

  const [editShopDialogOpen, setEditShopDialogOpen] = useState(false);


  const [supplierName, setSupplierName] = useState("");
  const [supplierNumber, setSupplierNumber] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [addTripSideBarOpen, setAddTripSideBarOpen] = useState(false);

  const [multiUserAddOpen, setMultiUserAddOpen] = useState(false);
  const [addUserInfo, setAddUserInfo] = useState({});
  const [inviteSuccess, setInviteSuccess] = useState(false);

  const [addSupplierPayment, setAddSupplierPayment] = useState(false);
  const [supplierPassbookPopUpOpen, setSupplierPassbookPopUpOpen] = useState(false);

  // Single Invoice State Varaibles
  const [invoiceEditFlag, setInvoiceEditFlag] = useState(false);
  const [invoiceDeleteOpen, setInvoiceDeleteOpen] = useState(false);
  const [singleInvoicePdf, setSingleInvoicePdf] = useState(false);
  const [singleInvoiceData, setSingleInvoiceData] = useState({});

  const [deleteShopDialogOpen, setDeleteShopDialogOpen] = useState(false);

  const [invoiceAddPayment, setInvoiceAddPayment] = useState(false);

  const [addPartyBalanceOpen, setAddPartyBalanceOpen] = useState(false);
  const [editPartyBalanceOpen, setEditPartyBalanceOpen] = useState(false);

  //Edit Load
  const [editLoadSideBar, setEditLoadSideBar] = useState(false);

  // **************************************** Diesel Card Related state variables ****************************************
  const [dieselCardRechargeSideBarOpen, setDieselCardRechargeSideBarOpen] = useState(false);
  const [dieselCardTruckDetails, setDieselCardTruckDetails] = useState({});

  const prevOpen = React.useRef(open);

  const dieselCardConfig = user && user.fuelCardConfig ? user.fuelCardConfig : {}

  useEffect(() => {

    if (user.showAddTripOverlay) {
      setIsTourOpen(true);
      trackDwebEvent("Dweb New User Add Trip Nudge", {})
    } else {
      setIsTourOpen(false);
    }
  }, [user.showAddTripOverlay]);

  useEffect(() => {
    if (trip && (trip.editInvoiceFlag || trip.editInvoiceFlag == false)) {
      setInvoiceEditFlag(trip.editInvoiceFlag);
    }
  }, [trip.editInvoiceFlag])

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (vehicle && vehicle.singleVendorDetails) {
      setSupplierName(vehicle.singleVendorDetails.vendorName);
      setSupplierNumber(vehicle.singleVendorDetails.vendorNumber);
    }
  }, [vehicle.singleVendorDetails]);

  useEffect(() => {
    setUserInfo(user.userInfoProfile)
  }, [user.userInfoProfile]);

  useEffect(() => {

    if (trip && trip.singleInvoiceInfo && trip.singleInvoiceInfo.invoiceDetails) {
      setSingleInvoiceData(trip.singleInvoiceInfo.invoiceDetails)
    }

  }, [trip.singleInvoiceInfo]);

  useEffect(() => {

    if (location && location.pathname && location.pathname.includes('/single-supplier')) {
      const checkPopUp = localStorage.getItem('SupplierPassbookPopUpShown');
      if (!checkPopUp) {
        setSupplierPassbookPopUpOpen(true);
      }
    }

  }, [location]);

  const handleEditLoadClose = () => {
    setEditLoadSideBar(false)
    fetchTrip(tripId);
  }
  const handleEditLoadOpen = () => {
    fetchTrip(tripId);
    setEditLoadSideBar(true)
  }

  const handleFastagRechargeOpen = () => {
    dispatchGetSingleFastagVehicleDetails(currentId,
      (data) => {
        if (data && data.status && data.status.code == 200) {
          dispatchGetWalletBalance(data, (res) => {
            if (data && data.status && data.status.code == 200) {
              setFastagRechargeOpen(true)
            }
          }, () => {

          })
        }
      },
      () => {
      }
    )
  }
  const handleFastagRechargeClose = () => {
    setFastagRechargeOpen(false)
  }
  const classes = headerStyles();
  const accentColor = "#5cb7b7";
  let history = useHistory();
  let dateFilterValues = getTripStartDateFilterValues();
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripDetails = user.singleTripData ? user.singleTripData : {};
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : path[path.length - 1];

  // ************************************ Fetching Id in url from present Page if present. ************************************
  let currentId = path && path[path.length - 1] ? path[path.length - 1] : ""
  let fastagDefaultData = {
    id: currentId ? currentId : null,
    vehicleId: currentId ? currentId : null
  }
  const tourConfig = [
    {
      selector: '[data-tut="reactour__addTrip"]',
      content: () => (
        <div className={classes.divTour}>
          <div className={classes.tourText}>
            Click here to add Trip
          </div>
          <div className="curvedarrow"></div>
        </div>
      ),
      position: 'right',

    }
  ]

  const handleAddVehicleOpen = () => {
    toggleAddVehicleOpen(true);
  };
  let disabledMenu = false;
  let userInfos = JSON.parse(localStorage.getItem("USER_INFO"));
  if (user && user.userInfo && user.userInfo.role && user.userInfo.role != "USER" && ((payments && payments.subscriptionStatus
    && typeof payments.subscriptionStatus.isExpired != 'undefined' && payments.subscriptionStatus.isExpired) ||
    (userInfos && typeof userInfos.isSubscriptionActive != 'undefined' && !userInfos.isSubscriptionActive))) {
    disabledMenu = true;
  }
  const vehicleLedgerRequestData = {
    fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
    ownershipType: ["SELF", "HIRED"],
    vehicleStatus: ["AVAILABLE", "ONTRIP"],
  };
  const handleAddVehicleClose = () => {
    toggleAddVehicleOpen(false);
    dispatchGetVehicleLedgerAction(vehicleLedgerRequestData);
  };
  const handleVehicleSave = (status, response) => {
    toggleAddVehicleOpen(false);
    dispatchGetVehicleLedgerAction(vehicleLedgerRequestData);
  }


  const handleAddEditTripSideBarOpen = () => setAddEditTripSideBarOpen(true);
  const handleAddEditTripSideBarClose = (status) => {
    setAddEditTripSideBarOpen(status)
    fetchTrip(tripId);
  };
  const handleAddPartyPaymentOpen = (status) => {
    setAddPartyPaymentOpen(true);
  };
  const getDateRangeValue = () => {
    let date = `${moment(dateFilterValues[parties.tripsTabFilter.selectedFilterDate]["startDateRange"]["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(dateFilterValues[parties.tripsTabFilter.selectedFilterDate]["startDateRange"]["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
    /*if (customFilterValue && customFilterValue.startTimeEpoch) {
      date = `${moment(customFilterValue["startTimeEpoch"] * 1000).format('YYYY-MM-DD')},${moment(customFilterValue["endTimeEpoch"] * 1000).format('YYYY-MM-DD')}`;
    }*/
    return [date]
  }
  const
    fetchSinglePartyTrips = () => {
      let partyId = location && location.state && location.state.partyId ? location.state.partyId : null;
      if (partyId) {
        var singlePartyLedgerRequestData = {
          ...partyLedgerRequestData,
          ...{ customerId: partyId },
          ...{
            filters: [
              {
                "filterKey": "customerId",
                "values": [partyId]
              },
              {
                "filterKey": "tripStatus",
                "values": TRIP_FILTER_STATUS_MAPPING[parties.tripsTabFilter.selectedFilterStatus]
              },
              {
                "filterKey": "startDate",
                "values": getDateRangeValue()
              }
            ]
          },
          ...{ status: TRIP_FILTER_STATUS_MAPPING[parties.tripsTabFilter.selectedFilterStatus] },
          ...{ startDateRange: dateFilterValues[parties.tripsTabFilter.selectedFilterDate]["startDateRange"] }
        };
        dispatchGetSinglePartyLedgerAction(singlePartyLedgerRequestData, () => {
        });
      }
    }
  const fetchMontlyBalances = () => {
    let partyId = location && location.state && location.state.partyId ? location.state.partyId : null;
    if (partyId) {
      dispatchGetSinglePartyMonthlyBalancesAction(partyId, () => {
      },
        () => {

        });
    }

  }
  const refreshPartyPage = () => {
    if (location && location.pathname && location.pathname.includes("/single-party/passbook")) {
      fetchPartyPayments();
    } else if (location && location.pathname && location.pathname.includes("/single-party/trips")) {
      fetchSinglePartyTrips();
    } else if (location && location.pathname && location.pathname.includes("/single-party/monthly-balances")) {
      fetchMontlyBalances();
    }
  }
  const refreshAfterEdit = () => {
    let partyId = (location && location.state && location.state.partyId) ? location.state.partyId : "";
    dispatchGetPartyDetails(partyId, (data) => {
      if (data && data.status && data.status.code == 200) {
        if (location && location.pathname && location.pathname.includes("/single-party/passbook")) {
          fetchPartyPayments();
        } else if (location && location.pathname && location.pathname.includes("/single-party/trips")) {
          fetchSinglePartyTrips();
        } else if (location && location.pathname && location.pathname.includes("/single-party/monthly-balances")) {
          fetchMontlyBalances();
        }
      }
    }, () => {

    })
  }
  const handleAddPartyPaymentClose = (status) => {
    setAddPartyPaymentOpen(false);
    refreshPartyPage()
    dispatchChatView(true);
  };
  const handleEditOpeningBalanceClose = () => {
    setEditPartyBalanceOpen(false)
    refreshAfterEdit()
  }
  const handleAddOpeningBalanceClose = () => {
    setAddPartyBalanceOpen(false)
    refreshAfterEdit()
  }
  const handleEditOpeningBalanceOpen = () => {
    let partyId = (location && location.state && location.state.partyId) ? location.state.partyId : "";
    dispatchGetPartyDetails(partyId, (data) => {
      if (data && data.status && data.status.code == 200) {
        setEditPartyBalanceOpen(true)
      }
    }, () => {

    })
  }
  const handleAddOpeningBalanceOpen = () => {
    let partyId = (location && location.state && location.state.partyId) ? location.state.partyId : "";
    dispatchGetPartyDetails(partyId, (data) => {
      if (data && data.status && data.status.code == 200) {
        setAddPartyBalanceOpen(true)
      }
    }, () => {

    })
  }
  const handleAddPartyPaymentSave = (status) => {
    let partyId = (location && location.state && location.state.partyId) ? location.state.partyId : "";
    let partyName = (location && location.state && location.state.pageTitle) ? location.state.pageTitle : "";
    setAddPartyPaymentOpen(false);
    dispatchChatView(true);
    if (location && location.pathname && location.pathname.includes("/single-party/passbook")) {
      refreshPartyPage()
    } else {
      history.push({
        pathname: `/parties/single-party/passbook/${partyId}`,
        state: {
          id: 7,
          partyId: partyId || null,
          pageTitle: partyName ? partyName : 'Party View'
        }
      });
    }
  };

  const handleAddTripSideBarOpen = () => {
    closeTour();
    // user.showAddTripOverlay = false;
    dispatchToggleTripOverlay();
    if ((location && location.state && location.state.vehicleStatus) && singleTruckData.status == "ONTRIP") {
      setCompleteTripOpen(true);
    } else {
      setAddTripSideBarOpen(true);
    }
  };

  const handleTripCompleteActionConfirm = () => {
    let id = singleTruckData && singleTruckData.id ? singleTruckData.id : ""
    let prefix = singleTruckData && singleTruckData.vehicleNumberPrefix ? singleTruckData.vehicleNumberPrefix : "";
    let suffix = singleTruckData && singleTruckData.vehicleNumberSuffix ? singleTruckData.vehicleNumberSuffix : "";
    let ownershipTypeValue = singleTruckData && singleTruckData.ownershipType ? singleTruckData.ownershipType : "";
    let bodyTypeValue = singleTruckData && singleTruckData.vehicleBodyType ? singleTruckData.vehicleBodyType : "";

    setCompleteTripOpen(false);
    singleTruckRecall(id, prefix, suffix, ownershipTypeValue, bodyTypeValue);
  }
  const fetchPartyPayments = () => {
    let partyId = location && location.state && location.state.partyId ? location.state.partyId : null;
    if (partyId) {
      var singlePartyLedgerRequestData = {
        ...{ customerId: Number(partyId) },
        ...{ transactionType: TRIP_TRANSACTION_FILTER[parties.paymentTabFilter.selectedFilterTransaction] },
        ...{ startDateRange: dateFilterValues[parties.paymentTabFilter.selectedFilterDate]["startDateRange"] }
      };
      let sparkLineRequets = {
        filters: {
          ...{ customerId: partyId }
        }
      }
      dispatchGetSinglePartyTripSparkLine(sparkLineRequets, () => {
        dispatchGetSinglePartyPayments(singlePartyLedgerRequestData, () => {

        }, () => {

        });
      }, () => {

      });
    }
  }
  // Recalling Sinlge Truck Page.
  const singleTruckRecall = (id, prefix, suffix, ownershipTypeValue, bodyTypeValue) => {

    var dateFilterValueUtil = getTripDateFilterValues();

    var startDateRange = dateFilterValueUtil["ALL_MONTHS"].startDateRange;

    var PandLdata = {
      vehicleId: id,
      startDateRange: {
        startTimeEpoch: startDateRange.startTimeEpoch,
        endTimeEpoch: startDateRange.endTimeEpoch
      }
    };

    var expenseData = {
      vehicleId: id,
      startDateRange: {
        startTimeEpoch: startDateRange.startTimeEpoch,
        endTimeEpoch: startDateRange.endTimeEpoch
      },
      expenseParentType: []
    };

    let defaultDateFilterValue = "ALL_MONTHS";
    let defaultTripBookFilterValue = "All Trips & Expenses";

    dispatchGetSingleTruck(id,
      (data) => {
        if (data && data.status && data.status.code == 200) {
          logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Successfull ");
          dispatchGetPandL(PandLdata, defaultDateFilterValue,
            (data) => {
              if (data && data.status && data.status.code == 200) {
                logger.log("Single Vehicle Component Dweb", "Get P and L report Successfull");
                dispatchGetTripExpenses(expenseData, defaultTripBookFilterValue,
                  (data) => {
                    if (data && data.status && data.status.code == 200) {
                      logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Successfull");
                      setAddTripSideBarOpen(true);
                      history.push({
                        pathname: `/trucks/single-truck/${id}`,
                        state: {
                          id: 8,
                          vehicleStatus: "Available",
                          pageTitle: (prefix && suffix) ? [prefix, suffix] : null,
                          vehicleId: id,
                          ownershipType: ownershipTypeValue,
                          bodyType: bodyTypeValue
                        }
                      });
                    }
                  },
                  () => {
                    logger.log("Single Vehicle Component Dweb", "Get Trip Expenses report Failed");
                  },
                )
              }
            },
            () => {
              logger.log("Single Vehicle Component Dweb", "Get P and L report Failed");
            },
          )
        }
      },
      () => {
        logger.log("Single Vehicle Component Dweb", "Get Single Truck Data Failed");
      }
    );
  }

  const handleTripCompleteActionClose = () => {
    setCompleteTripOpen(false);
  }

  const singleDriverData = vehicle.singleDriverData;
  let singleTruckData = vehicle.singleTruck;

  const singlePartyData = {
    customerId: (location.state && location.state.partyId) ? location.state.partyId : "",
    name: location.state && location.state.pageTitle ? location.state.pageTitle : "",
    openingBalanceDate: location.state && location.state.openingBalanceDate ? location.state.openingBalanceDate : ""
  }

  const handleAddTripSideBarClose = (status) => {
    setAddTripSideBarOpen(status);
    vehicle.singleTruck = {};
    singleTruckData = {};
    dispatchGetTripLedgerAction({
      fleetOwnerId: user.userInfo.entityId,
      pageNo: defaultPageNo,
      pageSize: defaultPageSize,
    }, () => {

    }, () => {

    })
  };

  const handleSettingdToggle = event => setAnchorEl(event.currentTarget);

  const handleCloseMenu = () => setAnchorEl(null);
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  const goToTrip = () => {
    history.push({
      pathname: '/trips/create',
      state: {
        id: 7,
        pageTitle: 'Create Trip'
      }
    });
  }
  const handleDrawerToggle = () => {
    toggleDrawer();
  };
  const onTripDeleteSucees = () => {
    setDeleteTripOpen(false);
    history.push({
      pathname: '/trips',
      state: {
        id: 7,
        pageTitle: 'Trips'
      }
    });
  }
  const onTripDeleteNo = () => {
    setDeleteTripOpen(false);
    fetchTrip(tripId)
  }
  const handleNotificationToggle = () => {
    toggleNotifications();
  };

  const goDriverGave = () => {
    setDriverNameModalOpen(true);
    setType("driverGave");
  };

  const goDriverGot = () => {
    setDriverNameModalOpen(true);
    setType("driverGot");
  }

  const handleDriverGaveModelClose = () => {
    setDriverNameModalOpen(false);
  }

  const handleAddDriverModalClose = () => {
    setDriverModalOpen(false);
  }

  const handleOnConfirm = () => {
    dispatchGetSparklineBalances(
      () => {
        logger.log("Drivers dWeb", "Get Sparkline Balances Successfull");
        setDriverModalOpen(false);
      },
      () => {
        logger.log("Drivers dWeb", "Get Sparkline Balances Failed");
      }
    )
  }

  const handleAddPartyClick = () => {
    setAddPartyOpen(true);
  }
  const handleAddShopClick = () => {
    setAddShopOpen(true);
  }
  const handleAddDriverClick = () => {
    setDriverModalOpen(true);
  }
  const handleAddPartyModalClose = (status) => {
    setAddPartyOpen(status);
  }
  const handleAddShopModalClose = (status) => {
    setAddShopOpen(status);
  }

  const goSingleDriverGave = () => {
    setDialogGaveAndGot(true);
    setType("driverGave");
  }
  const goSingleShopCredit = () => {
    setDialogShopCreditPayment(true);
    setType("Credit");
  }
  const goSingleShopPayment = () => {
    setDialogShopCreditPayment(true);
    setType("Payment");
  }
  const goSingleDriverGot = () => {
    setDialogGaveAndGot(true);
    setType("driverGot");
  }

  const handleBalanceClose = () => {
    setDialogGaveAndGot(false);
  }

  const handleShopCreditPaymetClose = () => {
    setDialogShopCreditPayment(false);
  }

  const handleMenuClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  }

  const handleMenuCloseSupplier = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpenSupplier(false);
  }
  const fetchSingleDriver = () => {
    var data = {
      pageNo: defaultPageNo,
      pageSize: defaultPageSize
    }

    const id = location.state && location.state.driverId ? location.state.driverId : "";

    dispatchGetSingleDriver(id, data,
      () => {
        logger.log("singleDriverComponent", "Single Driver Fetch Successfull");
        setDialogGaveAndGot(false);
      },
      () => {
        logger.log("singleDriverComponent", "Single Driver Fetch Failed");
      }
    )
  }
  const handleConfirm = () => {
    fetchSingleDriver();
  }

  const handleShopCreditPaymentConfirm = () => {
    setDialogShopCreditPayment(false);
  }

  const handlePartySave = (status) => {
    if (status) {
      dispatchGetPartyLedgerAction(partyLedgerRequestData, () => {
      }, () => {
      })
    }
  }
  const handleShopSave = (status) => {
    if (status) {
    }
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleToggleSupplier = () => {
    setOpenSupplier((prevOpen) => !prevOpen);
  }

  const handleDeleteDriver = (event) => {
    setDeleteDialog(true);
    handleMenuClose(event)
  }

  const handleDeleteDriverDialogClose = () => {
    setDeleteDialog(false);
  }

  const onDeleteDriver = () => {

    const id = location.state && location.state.driverId ? location.state.driverId : "";

    dispatchDeleteDriver(id,
      (data) => {
        if (data && data.status && data.status.code == 200) {
          setDeleteDialog(false);
          history.push({
            pathname: `/drivers`,
            state: {
              id: 1,
              pageTitle: 'Drivers'
            },
          });
          logger.log("Single Driver Component Dweb", "Driver deleted successfully");
        }
      },
      () => {
        logger.log("Single Driver Component Dweb", "Driver deleted failed");
      }
    )
  }

  const handleEditDriver = (event) => {
    setEditDriverDialog(true);
    handleMenuClose(event)
  }

  const handleEditClose = () => {
    setEditDriverDialog(false);
  }

  const validate = values => {
    const errors = {};

    let number = values.number ? /^[6-9]{1}[0-9]{9}$/.test(values.number.replace("-", "")) : "";

    if (!values.name) {
      errors.date = "Please enter driver name"
    }
    if (values.number && !/^[6-9]{1}[0-9]{9}$/.test(values.number.replace("-", ""))) {
      errors.number = "Please enter a valid mobile number"
    }

    return errors;
  }

  // const onSubmit = values => {

  //   const id = location.state && location.state.driverId ? location.state.driverId : "";

  //   var data = {
  //     name: values.name,
  //     contactNumber: values.number ? values.number.replace("-", "") : null,
  //     sendSMS: driverSendSms,
  //   }

  //   var singleDriverData = {
  //     pageNo: 1,
  //     pageSize: 200
  //   }

  //   dispatchEditDriver(id, data,
  //     (data) => {
  //       if (data && data.status && data.status.code == 200) {
  //         logger.log("SIngle Driver Component Dweb", "Edit Driver Successfull");
  //         setEditDriverDialog(false);
  //         sendSucces("Driver Updated Successfully.")
  //         dispatchGetSingleDriver(id, singleDriverData,
  //           (data) => {
  //             if (data && data.status && data.status.code == 200) {
  //               logger.log("singleDriverComponent", "Single Driver Fetch Successfull");
  //               history.push({
  //                 pathname: `/drivers/single-driver/${id}`,
  //                 state: {
  //                   id: 8,
  //                   driverStatus: (data.response && data.response.status) ? data.response.status : null,
  //                   pageTitle: data.response.name ? data.response.name : 'Driver View',
  //                   driverId: id
  //                 }
  //               })
  //             }
  //           },
  //           () => {
  //             logger.log("singleDriverComponent", "Single Driver Fetch Failed");
  //           }
  //         )
  //       }
  //     },
  //     () => {
  //       logger.log("SIngle Driver Component Dweb", "Edit Driver Failed");
  //     }
  //   )
  // }

  const handleNewDriverSendSms = (value) => {
    setDriverSendSms(value);
  }

  const handleEditProfile = () => {
    dispatchChatView(false);
    setEditProfileModal(true);
    trackDwebEvent("Dweb Profile Update Initiated", {});
  }

  const handleEditProfileDialogClose = () => {
    setEditProfileModal(false);
    dispatchChatView(true);
    dispatchFetchUserDetails(
      () => {
        logger.log("Header component Dweb", "Fetch user details successfull");
      },
      () => {
        logger.log("Header component Dweb", "Fetch user details failed");
      }
    );
  }

  const handleDeleteTrip = () => {
    let journey = user && user.singleTripData ? user.singleTripData : {}
    if (journey && journey.trips && journey.trips.length > 1) {
      handleEditLoadOpen()
    } else {
      setDeleteTripOpen(true);
    }
  }

  const handleEditProfileDialogOnConfirm = () => {
    setEditProfileModal(false);
    dispatchChatView(true);
    dispatchFetchUserDetails(
      () => {
        logger.log("Header component Dweb", "Fetch user details successfull");
      },
      () => {
        logger.log("Header component Dweb", "Fetch user details failed");
      }
    );
  }

  const handleEditParty = () => {
    setEditPartyDialogOpen(true);
  }

  const handleDeleteParty = () => {
    setDeletePartyDialogOpen(true);
  }

  const handleEditPartyModalClose = () => {
    setEditPartyDialogOpen(false);
  }

  const handleEditPartySave = (value) => {
    let partyId = (location.state && location.state.partyId) ? location.state.partyId : "";
    //fetchSinglePartyTrips();
    dispatchGetPartyDetails(partyId, (data) => {
      if (data && data.status && data.status.code == 200) {
        refreshPartyPage()
        let party = data.response;
        history.push({
          pathname: `/parties/single-party/trips/${partyId}`,
          state: {
            id: 7,
            partyId: partyId || null,
            pageTitle: party.customerName ? party.customerName : 'Party View',
            openingBalanceDate: party && party.openingBalance && party.openingBalance.date ? party.openingBalance.date : null
          }
        });
      }
    }, () => {

    })
  }

  const handleDeletePartyClose = () => {
    setDeletePartyDialogOpen(false);
  }

  const handleDeletePartyConfirm = () => {
    history.push({
      pathname: '/parties',
      visible: true,
      type: 'submenu',
      state: {
        id: 1,
        pageTitle: 'Parties'
      },
    });
    setDeletePartyDialogOpen(false);
  }

  const handleAddSupplier = () => {
    setAddSupplier(true);
  }

  const handleAddSupplierClose = () => {
    setAddSupplier(false);
  }

  const handleSupplierSave = () => {
    const vendorLedgerRequestData = {
      fleetOwnerId: user.userInfo.entityId,
      pageNo: defaultPageNo,
      pageSize: defaultPageSize,
    };
    dispatchGetVendorLedgerAction(vendorLedgerRequestData);
  }

  const handleEditSupplier = (event) => {

    let defaultId = location.state && location.state.vendorId ? location.state.vendorId : "";
    handleMenuCloseSupplier(event);

    dispatchGetSingleVendorDetails(
      defaultId,
      () => {
        logger.log("Add Supplier Component Dweb", "Get Single Supplier Details Successfull");
        setEditSupplierDialogOpen(true);
      },
      () => {
        logger.log("Add Supplier Component Dweb", "Get Single Supplier Details Failed");
      }

    )

  }
  const handleEditShop = (event) => {
    setEditShopDialogOpen(true);
  }

  const handleDeleteSupplier = (event) => {
    setDeleteSupplierDialogOpen(true);
    handleMenuCloseSupplier(event);
  }

  const handleEditSupplierClose = () => {
    setEditSupplierDialogOpen(false);
  }

  const handleEditShopClose = () => {
    setEditShopDialogOpen(false);
  }

  const handleSupplierSaveEdit = (value) => {
    setEditSupplierDialogOpen(false);

    let vendorId = value && value.id ? value.id : "";
    let vendorName = value && value.vendorName ? value.vendorName : "";
    history.push({
      pathname: `/suppliers/single-supplier/trips/${vendorId}`,
      state: {
        id: 8,
        pageTitle: vendorName ? vendorName : 'Vendor View',
        vendorId: vendorId
      }
    });
  }
  const handleShopSaveEdit = (value) => {

    setEditShopDialogOpen(false);
    const shopId = value && value.id ? value.id : "";
    const shopName = value && value.name ? value.name : "";
    const balance = value && value.balance ? value.balance : "";
    const number = value && value.contact_number ? value.contact_number : "";

    history.push({
      pathname: `/shops/shop/${shopId}`,
      state: {
        id: shopId,
        shopBalance: balance || null,
        pageTitle: shopName ? shopName : 'Shop View',
        shopName: shopName ? shopName : '',
        shopNumber: number ? number : "",
        shopId: shopId
      }
    });
  }

  const handleDeleteSupplierDialogClose = () => {
    setDeleteSupplierDialogOpen(false);
  }

  const handleDeleteShopDialogClose = () => {
    setDeleteShopDialogOpen(false);
  }

  const handleDeleteSupplierConfirm = () => {
    setDeleteSupplierDialogOpen(false);
    history.push({
      pathname: '/suppliers',
      type: 'submenu',
      state: {
        id: 1,
        pageTitle: 'Suppliers'
      },
    })
  }

  const handleDeleteShop = (event) => {
    setDeleteShopDialogOpen(true);
  }
  const handleDeleteShopConfirm = () => {
    setDeleteShopDialogOpen(false);
    history.push({
      pathname: '/shops',
      type: 'submenu',
      state: {
        id: 1,
        pageTitle: 'Shop Khata'
      },
    })
  }

  const handleAddExpense = () => {
    setAddExpenseDialog(true);
  }

  const handleComingSoonModalClose = () => {
    setComingSoonModal(false);
  }

  const handleSettingsClick = () => {
    if (!disabledMenu && user && user.userInfo && user.userInfo.role && user.userInfo.role != "USER") {
      history.push({
        pathname: '/profile/account',
        name: 'Profile',
        state: {
          id: 1,
          pageTitle: 'Profile'
        },
        type: 'submenu',
      });
    }
  }

  const handleCloseAddExpense = () => {
    setAddExpenseDialog(false);
  }

  const handleBack = () => {
    let journey = user && user.singleTripData ? user.singleTripData : {}
    if (journey && journey.id) {
      history.push({
        pathname: `/trips/view/${journey.id}`,
        state: {
          id: 7,
          tripData: user.singleTripData,
          tripView: true,
          pageTitle: 'Trip Details',
          pageSubTitle: user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.vehicleNumber ? user.singleTripData.vehicle.vehicleNumber : ''
        }
      });
    }

  }

  const disableBody = target => {
    disableBodyScroll(target);
  }

  const enableBody = target => {
    dispatchToggleTripOverlay();
    localStorage.setItem("CheckTripOverlay", "checking");
    enableBodyScroll(target);
  }

  const closeTour = () => {
    setIsTourOpen(false);
  }

  const handleMultiUserAddClose = () => {
    setMultiUserAddOpen(false);
  }

  const handleMultiUserAddSave = (values) => {
    setMultiUserAddOpen(false);
    setInviteSuccess(true);
    setAddUserInfo(values);
    dispatchGetMultiUserList(
      (data) => {
        if (data && data.status && data.status.code == 200) {
          logger.log('Header Dweb', "Get Multi User List Successfull");
        }
      },
      () => {
        logger.log('Header Dweb', "Get Multi User List Failed");
      }
    )
  }

  const handleAddUser = () => {
    trackDwebEvent("Dweb Add User initiated", {});
    setMultiUserAddOpen(true);
  }

  const handleMultiUserInviteSuccessClose = () => {
    setInviteSuccess(false);
  }

  const addPaymentSingleSupplier = (name) => {
    setTimeout(() => {
      setSupplierName(name);
      setAddSupplierPayment(true);
    }, 100);
  }

  const handleSingleSupplierPaymentClose = () => {
    setAddSupplierPayment(false);
  }

  const handleSingleSupplierPaymentConfirm = () => {
    if (location.pathname.includes("/single-supplier/passbook")) {

      let vendorLedgerRequestData = {
        fleetOwnerId: user.userInfo.entityId,
        vendorId: currentId ? currentId : "",
        status: TRIP_FILTER_STATUS_MAPPING["ACTIVE"],
        startDateRange: dateFilterValues["ALL_MONTHS"]["startDateRange"]
      }

      var singleSupplierTransactRequestData = {
        ...{ vendorId: currentId ? Number(currentId) : "" },
        ...{ transactionType: TRIP_TRANSACTION_FILTER["TRIPS_PAYMENTS"] },
        ...{ startDateRange: dateFilterValues["ALL_MONTHS"]["startDateRange"] }
      };

      dispatchGetSingleVendorLedger(vendorLedgerRequestData,
        (data) => {
          if (data && data.status && data.status.code == 200) {
            logger.log("Header  Dweb", "Single Supplier Fetch Successfull");
            dispatchFetchSupplierTransact(singleSupplierTransactRequestData,
              (data) => {
                if (data && data.status && data.status.code == 200) {
                  logger.log("Header Dweb", "Supplier Transaction Log Successfull");
                  setAddSupplierPayment(false);
                }
              },
              () => {
                logger.log("Header Dweb", "Supplier Transaction Log Failed");
              }
            )
          }
        },
        () => {
          logger.log("Header  Dweb", "Single Supplier Fetch Failed");
        }
      )

    } else {
      setAddSupplierPayment(false);
      history.push({
        pathname: `/suppliers/single-supplier/passbook/${currentId}`,
        state: {
          id: 8,
          pageTitle: user && user.singleVendorPageName ? user.singleVendorPageName : 'Vendor View',
          vendorId: currentId
        }
      });
    }
  }


  const handleAddInvoice = () => {
    setAddInvoiceFlag(true);
  }

  const handleAddInvoiceClose = () => {
    setAddInvoiceFlag(false);
  }

  const handleAddInvoiceConfirm = () => {
    setAddInvoiceFlag(false);
  }

  const handleEditInvoice = () => {
    const singleInvoiceData = trip && trip.singleInvoiceInfo ? trip.singleInvoiceInfo : {}
    dispatchEditInvoiceFlag(true);
    setInvoiceEditFlag(true);
    trackDwebEvent('Dweb Invoice edit initiated', {
      party_name: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.customerName ? singleInvoiceData.invoiceDetails.customerName : "",
      party_id: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.customerId ? singleInvoiceData.invoiceDetails.customerId : "",
      count_of_trips: singleInvoiceData && singleInvoiceData.trips ? singleInvoiceData.trips.length : 0,
      total_invoice_amount: singleInvoiceData && singleInvoiceData.amounts && singleInvoiceData.amounts.total ? singleInvoiceData.amounts.total : "",
      invoice_number: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceNumber ? singleInvoiceData.invoiceDetails.invoiceNumber : "",
      invoice_date: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(singleInvoiceData.invoiceDetails.invoiceDate) : "",
      due_days: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.dueIn ? singleInvoiceData.invoiceDetails.dueIn : "",
      invoice_id: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.id ? singleInvoiceData.invoiceDetails.id : "",
      party_company_name: singleInvoiceData && singleInvoiceData.customerGSTDetails && singleInvoiceData.customerGSTDetails.companyName ? singleInvoiceData.customerGSTDetails.companyName : "",
      party_gst_number: singleInvoiceData && singleInvoiceData.customerGSTDetails && singleInvoiceData.customerGSTDetails.gstNumber ? singleInvoiceData.customerGSTDetails.gstNumber : "",
      user_company_name: singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.companyName ? singleInvoiceData.userGSTDetails.companyName : "",
      user_gst_number: singleInvoiceData && singleInvoiceData.userGSTDetails && singleInvoiceData.userGSTDetails.gstNumber ? singleInvoiceData.userGSTDetails.gstNumber : "",
      gst_percentage: singleInvoiceData && singleInvoiceData.otherDetails && singleInvoiceData.otherDetails.gstPercentage ? singleInvoiceData.otherDetails.gstPercentage : "",
      terms_and_conditions: singleInvoiceData && singleInvoiceData.otherDetails && singleInvoiceData.otherDetails.termsAndConditions ? singleInvoiceData.otherDetails.termsAndConditions : "",
      signature_url: singleInvoiceData && singleInvoiceData.otherDetails && singleInvoiceData.otherDetails.signatureLink ? singleInvoiceData.otherDetails.signatureLink : ""
    });
  }

  const handleInvoiceEditConfirm = () => {
    dispatchEditInvoiceFlag(false);
    setInvoiceEditFlag(false);
  }

  const handleDeleteInvoice = () => {
    setInvoiceDeleteOpen(true);
  }

  const handleDeleteInvoiceClose = () => {
    setInvoiceDeleteOpen(false);
  }

  const handleDeleteInvoiceConfirm = () => {
    setInvoiceDeleteOpen(false);
    history.push({
      pathname: '/invoices',
      state: {
        id: 1,
        pageTitle: 'Invoices'
      }
    });
  }

  const handleInvoicePdf = () => {
    setSingleInvoicePdf(true);
    const singleInvoiceData = trip && trip.singleInvoiceInfo ? trip.singleInvoiceInfo : {}
    trackDwebEvent('Dweb Invoice PDF view', {
      party_name: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.customerName ? singleInvoiceData.invoiceDetails.customerName : "",
      party_id: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.customerId ? singleInvoiceData.invoiceDetails.customerId : "",
      count_of_trips: singleInvoiceData && singleInvoiceData.trips ? singleInvoiceData.trips.length : 0,
      total_invoice_amount: singleInvoiceData && singleInvoiceData.amounts && singleInvoiceData.amounts.total ? singleInvoiceData.amounts.total : "",
      invoice_number: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceNumber ? singleInvoiceData.invoiceDetails.invoiceNumber : "",
      invoice_date: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(singleInvoiceData.invoiceDetails.invoiceDate) : "",
      due_days: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.dueIn ? singleInvoiceData.invoiceDetails.dueIn : "",
      invoice_id: singleInvoiceData && singleInvoiceData.invoiceDetails && singleInvoiceData.invoiceDetails.id ? singleInvoiceData.invoiceDetails.id : ""
    });
  }

  const handleSingleInvoicePdfClose = () => {
    setSingleInvoicePdf(false);
  }

  const handleInvoiceAddPayment = () => {
    setInvoiceAddPayment(true);
  }

  const handleInvoiceAddPaymentClose = () => {
    setInvoiceAddPayment(false);
  }

  const handleInvoiceAddPaymentConfirm = () => {

    dispatchGetSingleInvoice(currentId,
      (data) => {
        if (data && data.status && data.status.code == 200) {
          logger.log("Header Dweb", "Get Single Invoice Successfull");
          setInvoiceAddPayment(false);
        }
      },
      () => {
        logger.log("Header Dweb", "Get Single Invoice Failed");
      }
    );

  }

  const handleSupplierPassbookPopUpClose = () => {
    setSupplierPassbookPopUpOpen(false);
  }

  const addSupplierPaymentPopUp = () => {
    setTimeout(() => {
      setAddSupplierPayment(true);
    }, 100);
  }

  const handleEditDriverClose = () => {
    setEditDriverDialog(false);
  }

  const handleEditDriverConfirm = () => {

    setEditDriverDialog(false);

    const id = location.state && location.state.driverId ? location.state.driverId : "";

    var singleDriverData = {
      pageNo: 1,
      pageSize: 200
    }

    dispatchGetSingleDriver(id, singleDriverData,
      (data) => {
        if (data && data.status && data.status.code == 200) {
          logger.log("singleDriverComponent", "Single Driver Fetch Successfull");
          history.push({
            pathname: `/drivers/single-driver/${id}`,
            state: {
              id: 8,
              driverStatus: (data.response && data.response.status) ? data.response.status : null,
              pageTitle: data.response.name ? data.response.name : 'Driver View',
              driverId: id
            }
          })
        }
      },
      () => {
        logger.log("singleDriverComponent", "Single Driver Fetch Failed");
      }
    )
  }

  // ***************************************** Diesel Card Follow *****************************************
  const handleDieselCardRechargeClick = () => {
    setDieselCardRechargeSideBarOpen(true);
    if (vehicle && vehicle.singleDieselCardInfo) {
      setDieselCardTruckDetails(vehicle.singleDieselCardInfo)
    }
  }

  const handleDieselCardRechargeSideBarClose = () => {
    setDieselCardRechargeSideBarOpen(false);
  }

  const handleDieselCardRedirection = () => {

    const dieselCardDetails = vehicle && vehicle.singleDieselCardInfo ? vehicle.singleDieselCardInfo : {}

    history.push({
      pathname: `/diesel-card/single-diesel-card/${dieselCardDetails && dieselCardDetails.vehicleId ? dieselCardDetails.vehicleId : ""}/${dieselCardDetails && dieselCardDetails.fuelCardBrokerId ? dieselCardDetails.fuelCardBrokerId : 1}`,
      state: {
        id: 1,
        pageTitle: "Diesel Card",
        vehicleNumber: dieselCardDetails && dieselCardDetails.vehicleNumArrayValue ? dieselCardDetails.vehicleNumArrayValue : []
      }
    })
  }

  return (
    <>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar className={classes.toolBar}>
          <div className={classes.branding} onClick={() => handleSettingsClick()}>
            {/* <img src={logo} alt={logoAltText} className={classes.logo} /> */}
            <TransportBookContact className={classes.userIcon} />
            <div className={classes.userInfo}>
              <Typography variant="subtitle2" className={classes.companyName}>
                {userInfo && userInfo.companyName ? userInfo.companyName : ''}
              </Typography>
              <Typography variant="subtitle2" className={classes.userName}>
                {userInfo && userInfo.contactNumber ? userInfo.contactNumber : ''}
              </Typography>
            </div>
            {/* <IconButton className={classes.iconButtonV1}>
              <SettingsIcon />
            </IconButton> */}
          </div>
          {/* <TransportBookThumbnail className={classes.thumbnail}/> */}

          <div className={classes.divAlign}>

            {location && location.pathname && location.pathname.includes("/trips/sim-tracking-map") &&
              <div>
                <IconButton onClick={() => handleBack()}>
                  <ArrowBackIcon className={classes.arrowIcon} />
                </IconButton>
              </div>
            }
            <Typography variant="subtitle2" className={location && location.pathname && location.pathname.includes("/trips/sim-tracking-map") ? classes.thumbnailTextV1 : classes.thumbnailText}>
              {(location.pathname != "/profile/account" && location.pathname != "/profile/user-management" && typeof (location.state && location.state.pageTitle ? location.state.pageTitle : "") !== "object") &&
                <>
                  {location && location.pathname && location.pathname === "/payments" ? <PremiumMenuIcon style={{marginRight:8}} /> :null}
                  {location && location.state && location.state.pageTitle ? location.state.pageTitle : 'TransportBook'}
                </>
              }

              {/* For single vehicle page. */}
              {typeof (location.state && location.state.pageTitle ? location.state.pageTitle : "") == "object" &&
                <>
                  {location && location.state && location.state.pageTitle &&
                    <>
                      <span>{location.state.pageTitle[0]}</span><span className={classes.spanV3}>{location.state.pageTitle[1]}</span>
                    </>
                  }
                </>
              }
              {location && location.state && location.state.bodyType &&
                <>
                  <span className={classes.mlV2}>
                    <FiberManualRecordIcon className={classes.separatorCircle}></FiberManualRecordIcon>{" "}

                    <span className={classes.spanV4}>{location.state.bodyType}</span>

                  </span>
                </>
              }
              {location && location.state && location.state.vehicleStatus &&
                <>
                  <span className={classes.mlV2}>
                    <FiberManualRecordIcon
                      className={(location.state.vehicleStatus === 'Available') ? classes.circle : classes.circleOnTrip}
                    ></FiberManualRecordIcon>{" "}

                    <span className={classes.spanV4}>{location.state.vehicleStatus}</span>

                  </span>
                </>
              }

              {location && location.state && location.state.ownershipType &&
                <>
                  <span className={classes.mlV2}>
                    <FiberManualRecordIcon
                      className={classes.separatorCircle}
                    ></FiberManualRecordIcon>{" "}

                    {location && location.state && location.state.ownershipType && location.state.ownershipType == "SELF" &&
                      <span className={classes.ownTruck}>
                        Own
                      </span>
                    }
                    {location && location.state && location.state.ownershipType && location.state.ownershipType == "HIRED" &&
                      <span className={classes.marketTruck}>
                        Market
                      </span>
                    }
                  </span>
                </>
              }

              {/* For profile page.  */}
              {location && location.pathname == "/profile/account" &&
                <span>Profile</span>
              }

              {location && location.pathname == "/profile/user-management" &&
                <span>User Management</span>
              }

              {/* For Sim Tracking map page subtitle. */}
              {location && location.pathname && location.pathname.includes("/trips/sim-tracking-map")
                && location.state && location.state.sourceLocation && location.state.destinationLocation && 
                <div className={classes.simTrackingSubtitle}>
                  {location.state && location.state.sourceLocation ? location.state.sourceLocation : ""}&nbsp;&nbsp;-&nbsp;&nbsp;{location.state && location.state.destinationLocation ? location.state.destinationLocation : ""}
                </div>
              }

              {/* Incase page has subTitle. */}
              {location && location.state && location.state.pageSubTitle && location.pathname && !location.pathname.includes("/invoices/single-invoice") &&
                <>
                  <FiberManualRecordIcon className={classes.subTitleBullet} />
                  &nbsp;{location.state.pageSubTitle}
                </>}

              {/* ***************************************** Single Invoice Page ***************************************** */}
              {location && location.state && location.pathname && location.pathname.includes("/invoices/single-invoice") &&
                <>
                  {singleInvoiceData && singleInvoiceData.dueStatus &&
                    <>
                      <FiberManualRecordIcon className={classes.subTitleBulletV1} />
                      <span className={classes.subTitleV1}>{singleInvoiceData.dueStatus}</span>
                    </>
                  }
                </>
              }

              {location && location.state && location.state.tripView && tripDetails && tripStatus != 'PAYMENT_RECEIVED' && tripDetails.reminder_due_date && <>
                <span className={classes.reminderCard}>Payment Due<FiberManualRecordIcon className={classes.reminderBullet} /><span className={classes.reminderDate}>{tripDetails.reminder_due_date}</span></span>
              </>}
              {/* Driver status . Single Driver page. */}
              {location && location.state && location.state.driverStatus &&
                <>
                  <span className={classes.mlV1}>
                    <FiberManualRecordIcon
                      className={(location.state.driverStatus === 'AVAILABLE') ? classes.circle : classes.circleOnTrip}
                    ></FiberManualRecordIcon>{" "}

                    {
                      location.state.driverStatus == "AVAILABLE" &&
                      <span className={classes.spanV2}>Available</span>
                    }
                    {
                      location.state.driverStatus == "ONTRIP" &&
                      <span className={classes.spanV2}>On Trip</span>
                    }
                  </span>
                </>
              }

              {/* Trip Details Page. */}
              {location && location.state && location.state.pageTitle == "Trip Details" &&
                <>
                  <span>
                    {tripDetails && tripDetails.elr_number &&
                      <>
                        <FiberManualRecordIcon
                          className={classes.subTitleBulletV1}
                        ></FiberManualRecordIcon>
                        <span>{tripDetails.elr_number}</span>
                      </>
                    }
                  </span>
                </>
              }

              {/* ************************************ Single Diesel Card ************************************ */}
              {location && location.pathname && location.pathname.includes('/diesel-card/single-diesel-card') &&
                <>
                  <div className={classes.divAlignV1}>
                    <div className={classes.divMargin}><FiberManualRecordIcon className={classes.separatorCircle}></FiberManualRecordIcon></div>
                    <div className={classes.divAlignV1}>
                      {location.state && location.state.vehicleNumber && location.state.vehicleNumber.map((truckNumber, index) => (
                        <div className={index != 0 ? classes.ml4 : ""} ><span className={index == (location.state.vehicleNumber.length - 1) ? classes.blueColor : ""}>{truckNumber}</span></div>
                      ))}
                    </div>
                  </div>
                </>
              }

            </Typography>
            <div className={classes.grow} />
            <div className={classes.endDiv}>
              {location && location.state && location.state.pageTitle == 'Trucks' &&
                <>
                  <div>
                    <Button className={classes.addTruckButton} variant="contained" onClick={handleAddVehicleOpen} >
                      <AddIcon className={classes.mrV1} /> Add Truck
                    </Button>
                  </div>
                </>
              }
              {(location && location.pathname && location.pathname.includes("/fastag")) && location.state && !location.state.fastTagId &&
                <>
                  <div>
                    <Button className={classes.addTruckButtonFastag} variant="contained" onClick={handleAddVehicleOpen} >
                      <AddIcon className={classes.mrV1} /> Add Truck
                    </Button>
                  </div>
                </>
              }

              {location && location.state && location.state.pageTitle == 'Drivers' &&
                <>
                  <Button startIcon={<RemoveIcon />} variant="contained" onClick={goDriverGave} className={classes.driverGaveButtonV1}>
                    Driver Gave
                  </Button>
                  <Button startIcon={<AddRoundedIcon />} variant="contained" className={classes.driverGotButtonV1} onClick={goDriverGot}>
                    Driver Got
                  </Button>
                  <Button variant="contained" onClick={handleAddDriverClick} className={classes.addDriverButton}>
                    <AddIcon className={classes.mrV1} /> Add Driver
                  </Button>
                </>
              }

              {location && location.state && location.state.pageTitle == 'Parties' &&
                <>
                  <Button variant="contained" classes={{ root: classes.addPartyCta, label: classes.label, }} color="primary" onClick={handleAddPartyClick}>
                    <AddIcon /> Add Party
                  </Button>
                  <Button variant="contained" classes={{ root: classes.addTripCta, label: classes.label, }} color="primary" onClick={handleAddTripSideBarOpen} data-tut="reactour__addTrip" >
                    <AddIcon /> Add Trip
                  </Button>
                </>
              }

              {(location && location.state && location.state.pageTitle == 'Trips' || location && location.state && location.state.tripView) &&
                <>
                  {location && location.state && location.state.tripView && <>
                    <Button variant="outlined" classes={{ root: classes.editTripCta, }} onClick={handleEditLoadOpen} color="primary">
                      <EditIcon />&nbsp;Edit Trip
                    </Button>
                    <Button variant="outlined" classes={{ root: classes.deleteTripCta, }} color="primary" onClick={handleDeleteTrip}>
                      <DeleteIcon />&nbsp;Delete Trip
                    </Button>
                  </>}
                  {location && location.state && location.state.pageTitle == 'Trips' && <Button variant="contained" classes={{ root: classes.addTripCta, label: classes.label, }} color="primary" onClick={handleAddTripSideBarOpen}>
                    <AddIcon /> Add Trip
                  </Button>}
                </>
              }

              {(location && location.state && location.state.pageTitle == 'Suppliers') &&
                <>
                  <Button variant="contained" classes={{ root: classes.addSupplierButton, label: classes.label }} onClick={handleAddSupplier}>
                    <AddIcon /> Add Supplier
                  </Button>
                  <Button variant="contained" classes={{ root: classes.addTripCta, label: classes.label }} color="primary" onClick={handleAddTripSideBarOpen} >
                    <AddIcon /> Add Trip
                  </Button>
                </>
              }
              {(location && location.state && location.state.pageTitle == 'Shop Khata') &&
                <>
                  <Button variant="contained" classes={{ root: classes.addShopCta, label: classes.label }} color="primary" onClick={handleAddShopClick} >
                    <AddIcon /> Add Shop
                  </Button>
                </>
              }

              {/* ******************************************* Single Supplier Page Header Actions. ******************************************* */}
              {(location && location.pathname && location.pathname.includes("/suppliers/single-supplier")) &&
                <>
                  <Button variant="outlined" classes={{ root: classes.editTripCtaV1, }} onClick={handleEditSupplier} color="primary">
                    <EditIcon />&nbsp;Edit Supplier
                  </Button>
                  <Button variant="outlined" classes={{ root: classes.deleteTripCtaV1, }} color="primary" onClick={handleDeleteSupplier}>
                    <DeleteIcon />&nbsp;Delete Supplier
                  </Button>
                  <Button variant="outlined" classes={{ root: classes.addPaymentButton }} color="primary" onClick={() => addPaymentSingleSupplier(location && location.state && location.state.pageTitle ? location.state.pageTitle : "")} >
                    &#8377;&nbsp;&nbsp;&nbsp;Add Payment
                  </Button>
                  <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addTripButtonVehicle} onClick={handleAddTripSideBarOpen}>
                    <span className={classes.ptV1}>Add Trip</span>
                  </Button>
                  {/* <Button onClick={() => handleToggleSupplier()} ref={anchorRef} aria-controls={open ? 'menu-list-grow' : undefined} aria-haspopup="true" startIcon={<MoreHorizIcon className={classes.colorV1} />} variant="outlined" className={classes.moreButtonV1} >
                  More
                </Button>
                <Popper open={openSupplier} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                      <Paper className={classes.mtV3}>
                        <ClickAwayListener onClickAway={handleMenuCloseSupplier}>
                          <MenuList autoFocusItem={open} id="menu-list-grow">
                            <MenuItem onClick={handleEditSupplier} className={classes.menuItemV1} ><EditOutlinedIcon className={classes.editMenuIcon} />&nbsp;&nbsp;&nbsp;Edit Supplier</MenuItem>
                            <MenuItem onClick={handleDeleteSupplier} className={classes.menuItemV2}><DeleteOutlineOutlinedIcon className={classes.deleteMenuIcon} />&nbsp;&nbsp;Delete Supplier</MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper> */}
                </>
              }

              {location && location.state && location.state.driverId &&
                <>
                  <Button startIcon={<RemoveIcon />} variant="contained" onClick={goSingleDriverGave} className={classes.driverGaveButtonV1}>
                    Driver Gave
                  </Button>
                  <Button startIcon={<AddRoundedIcon />} variant="contained" color="primary" className={classes.driverGotButtonV1} onClick={goSingleDriverGot}>
                    Driver Got
                  </Button>
                  <Button onClick={() => handleToggle()} ref={anchorRef} aria-controls={open ? 'menu-list-grow' : undefined} aria-haspopup="true" startIcon={<MoreHorizIcon className={classes.colorV1} />} variant="outlined" className={classes.moreButton} >
                    More
                  </Button>
                  <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                      >
                        <Paper className={classes.mtV3}>
                          <ClickAwayListener onClickAway={handleMenuClose}>
                            <MenuList autoFocusItem={open} id="menu-list-grow">
                              <MenuItem onClick={handleEditDriver} className={classes.menuItemV1} ><EditOutlinedIcon className={classes.editMenuIcon} />&nbsp;&nbsp;&nbsp;Edit Driver</MenuItem>
                              <MenuItem onClick={handleDeleteDriver} className={classes.menuItemV2}><DeleteOutlineOutlinedIcon className={classes.deleteMenuIcon} />&nbsp;&nbsp;Delete Driver</MenuItem>
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </>
              }
              {location && location.state && location.state.shopId &&
                <>
                  <Button startIcon={<ArrowDownwardIcon />} variant="contained" onClick={goSingleShopCredit} className={classes.driverGaveButtonV1}>
                    Credit
                  </Button>
                  <Button startIcon={<ArrowUpwardIcon />} variant="contained" color="primary" className={classes.driverGotButtonV1} onClick={goSingleShopPayment}>
                    Payment
                  </Button>
                  <Button onClick={() => handleToggle()} ref={anchorRef} aria-controls={open ? 'menu-list-grow' : undefined} aria-haspopup="true" startIcon={<MoreHorizIcon className={classes.colorV1} />} variant="outlined" className={classes.moreButton} >
                    More
                  </Button>
                  <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                      >
                        <Paper className={classes.mtV3}>
                          <ClickAwayListener onClickAway={handleMenuClose}>
                            <MenuList autoFocusItem={open} id="menu-list-grow">
                              <MenuItem onClick={() => { handleEditShop() }} className={classes.menuItemV1} ><EditOutlinedIcon className={classes.editMenuIcon} />&nbsp;&nbsp;&nbsp;Edit Shop</MenuItem>
                              <MenuItem onClick={() => { handleDeleteShop() }} className={classes.menuItemV2}><DeleteOutlineOutlinedIcon className={classes.deleteMenuIcon} />&nbsp;&nbsp;Delete Shop</MenuItem>
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </>
              }

              {/* More Menu for single party page. */}
              {location.pathname.includes("/parties/single-party") &&
                <>
                  {/* <Button variant="outlined" classes={{ root: classes.editTripCtaV1, }} onClick={handleEditParty} color="primary">
                    <EditIcon />&nbsp;Edit Party
                  </Button>
                  <Button variant="outlined" classes={{ root: classes.deleteTripCtaV1, }} color="primary" onClick={handleDeleteParty}>
                    <DeleteIcon />&nbsp;Delete Party
                  </Button> */}
                  <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addPaymentButtonVehicle} onClick={handleAddPartyPaymentOpen}>
                    <span className={classes.ptV1}>Add Payment</span>
                  </Button>
                  <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addTripButtonVehicle} onClick={handleAddTripSideBarOpen}>
                    <span className={classes.ptV1}>Add Trip</span>
                  </Button>
                  <Button onClick={() => handleToggle()} ref={anchorRef} aria-controls={open ? 'menu-list-grow' : undefined} aria-haspopup="true" startIcon={<MoreHorizIcon className={classes.colorV1} />} variant="outlined" className={classes.moreButton} >
                    More
                  </Button>
                  <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                      <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                      >
                        <Paper className={classes.mtV3}>
                          <ClickAwayListener onClickAway={handleMenuClose}>
                            <MenuList autoFocusItem={open} id="menu-list-grow">
                              <MenuItem onClick={handleEditParty} className={classes.menuItemV1} ><EditOutlinedIcon className={classes.editMenuIcon} />&nbsp;&nbsp;&nbsp;Edit Party</MenuItem>
                              <MenuItem onClick={handleDeleteParty} className={classes.menuItemV2}><DeleteOutlineOutlinedIcon className={classes.deleteMenuIcon} />&nbsp;&nbsp;Delete Party</MenuItem>
                              {parties && parties.details && !parties.details.openingBalance &&
                                <MenuItem onClick={handleAddOpeningBalanceOpen} className={classes.menuItemV3}><AddRoundedIcon className={classes.obAdd} />&nbsp;Opening Balance</MenuItem>
                              }
                              {parties && parties.details && parties.details.openingBalance && parties.details.openingBalance.id &&
                                <MenuItem onClick={handleEditOpeningBalanceOpen} className={classes.menuItemV3}><EditOutlinedIcon className={classes.obAdd} />&nbsp;Opening Balance</MenuItem>
                              }
                            </MenuList>
                          </ClickAwayListener>
                        </Paper>
                      </Grow>
                    )}
                  </Popper>
                </>
              }

              {(location && location.pathname == "/profile/account") &&
                <Button startIcon={<EditIcon style={{ color: "#0033cc" }} />} variant="outlined" className={classes.editButtonV1} onClick={handleEditProfile}>
                  Edit
                </Button>
              }

              {/* Single Truck Page Header. */}
              {location && location.state && location.state.vehicleId &&
                <>
                  {location && location.state && location.state.ownershipType && location.state.ownershipType != "HIRED" && <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addExpenseButtonVehicle} onClick={() => handleAddExpense()}>
                    <span className={classes.ptV1}>Add Expense</span>
                  </Button>}
                  <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addTripButtonVehicle} onClick={handleAddTripSideBarOpen}>
                    <span className={classes.ptV1}>Add Trip</span>
                  </Button>
                </>
              }

              {(location && location.pathname == "/profile/user-management") &&
                <>
                  <Button
                    className={classes.addUserButton}
                    startIcon={<AddIcon />}
                    onClick={() => handleAddUser()}
                  >
                    Add User
                  </Button>
                </>
              }

              {(location && location.pathname == "/invoices") &&
                <>
                  <Button
                    variant="contained"
                    className={classes.addInvoiceButton}
                    startIcon={<AddIcon />}
                    onClick={() => handleAddInvoice()}
                  >
                    <span className={classes.mtV6}>Add Invoice</span>
                  </Button>
                </>
              }
              {/* ********************************************* Single Vehicle Fasttag ********************************************* */}
              {/* {location && location.state && location.state.fastTagId &&
                <>
                  <Button variant="contained" startIcon={<RechargeFastag className={classes.fsV1} />} className={classes.rechargeFastagButtonVehicle} onClick={() => { handleFastagRechargeOpen() }}>
                    <span className={classes.ptV1}>Recharge FASTag </span>
                  </Button>
                </>
              } */}

              {/* {location && location.pathname && location.pathname.includes("/single-diesel-card/") && vehicle && vehicle.singleDieselCardInfo && vehicle.singleDieselCardInfo.transactionLogs && vehicle.singleDieselCardInfo.transactionLogs.length > 0 &&
                <>
                  <Button variant='contained' startIcon={<RechargeFastag className={classes.fsV1} />} className={classes.dieselCardRecharge} onClick={() => handleDieselCardRechargeClick()}>
                    Recharge
                  </Button>
                </>
              } */}

              {location && location.state && location.state.pageTitle && location.state.pageTitle == "Diesel Card" &&
                <>
                  <Button variant='contained' endIcon={<HelpIcon className={classes.helpIconWhite} />} className={classes.helpButtonBlack} href={dieselCardConfig && dieselCardConfig.faq ? dieselCardConfig.faq : ""} target="_blank">
                    Help
                  </Button>
                </>
              }

              {location && location.pathname && location.pathname.includes('/invoices/single-invoice') &&

                <>
                  {!invoiceEditFlag &&
                    <>
                      <Button variant="outlined" startIcon={<EditIcon className={classes.editIcon} />} className={classes.editInvoice} onClick={() => handleEditInvoice()}>
                        <span className={classes.ptV1}>Edit Invoice</span>
                      </Button>
                      <Button variant="outlined" startIcon={<DeleteIcon className={classes.colorRed} />} className={classes.deleteInvoice} onClick={() => handleDeleteInvoice()}>
                        <span className={classes.ptV1}>Delete Invoice</span>
                      </Button>
                      {singleInvoiceData && singleInvoiceData.invoiceStatus && singleInvoiceData.invoiceStatus != "Paid" &&
                        <Button variant="contained" startIcon={<AddRoundedIcon className={classes.fsV1} />} className={classes.addPaymentButtonInvoice} onClick={() => handleInvoiceAddPayment()} >
                          <span className={classes.ptV1}>Add Payment</span>
                        </Button>
                      }
                    </>
                  }
                  {invoiceEditFlag &&
                    <>
                      <Button variant="contained" startIcon={<DoneIcon className={classes.doneIconV1} />} className={classes.confirmButtonInvoice} onClick={() => handleInvoiceEditConfirm()}>
                        <span className={classes.ptV1}>Confirm</span>
                      </Button>
                    </>
                  }
                  <Button variant="contained" startIcon={<PictureAsPdfOutlinedIcon className={classes.pdfIcon} />} className={classes.pdfPreviewInvoice} onClick={() => handleInvoicePdf()}>
                    <span className={classes.ptV1}>PDF Preview</span>
                  </Button>
                </>

              }


              {/* <Hidden xsDown>
              <IconButton color="inherit" onClick={toggleFullscreen}>
                <FullscreenIcon />
              </IconButton>
            </Hidden> */}

              {/* Notification Icon Button. */}
              {/* <IconButton color="inherit" onClick={handleNotificationToggle}>
              <Badge badgeContent={0} color="secondary">
                <NotificationsNoneOutlinedIcon />
              </Badge>
            </IconButton> */}

            </div>

            {/* <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerToggle}
        >
          <MenuIcon />
        </IconButton> */}
            {/*
        <IconButton
          aria-label="User Settings"
          aria-owns={anchorEl ? 'user-menu' : null}
          aria-haspopup="true"
          color="inherit"
          onClick={handleSettingdToggle}
        >
          <MoreVertIcon />
        </IconButton> */}
            {/* <div className={classes.userBadge}>
          <div className={classes.userInfo}>
              <Typography variant="h6" className={classes.companyName}>
                {userDetails.userInfo && userDetails.userInfo && userDetails.userInfo.companyName?userDetails.userInfo.companyName:''}
              </Typography>
              <Typography variant="subtitle2">
              {userDetails.userInfo && userDetails.userInfo && userDetails.userInfo.contactNumber?userDetails.userInfo.contactNumber:''}
              </Typography>
          </div> */}
            {disabledMenu && <IconButton
              aria-label="User Settings"
              aria-owns={anchorEl ? 'user-menu' : null}
              aria-haspopup="true"
              color="inherit"
              onClick={dispatchLogoutAction}
            >
              <ExitToAppIcon />
            </IconButton>}
            {/* <Menu
            id="user-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            <MenuItem onClick={handleCloseMenu}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary="Sign out" />
            </MenuItem>
          </Menu>
        </div> */}
          </div>
        </Toolbar>
      </AppBar>

      {/* Delete Driver Dialog. */}
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        disableBackdropClick={true} disableEscapeKeyDown={true} open={deleteDialog} onClose={handleDeleteDriverDialogClose}
      >
        <DialogContent>
          <div className={classes.divV25}> Delete Driver</div>
          <div className={classes.mtV5}>Do you want to delete Driver {location.state && location.state.pageTitle ? location.state.pageTitle : ""}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDriverDialogClose}>
            <span className={classes.cancelV1}>
              CANCEL
            </span>
          </Button>
          <Button onClick={onDeleteDriver}>
            <span className={classes.deleteV1}>
              DELETE
            </span>
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add trip tour. */}
      <Tour
        onRequestClose={closeTour}
        steps={tourConfig}
        isOpen={disabledMenu ? false : isTourOpen}
        // maskClassName="mask"
        className={classes.tourV1}
        disableKeyboardNavigation={true}
        // rounded={5}
        accentColor={accentColor}
        closeWithMask={true}
        disableDotsNavigation={true}
        onAfterOpen={disableBody}
        onBeforeClose={enableBody}
        showButtons={false}
        showCloseButton={false}
        showNavigation={false}
        showNavigationNumber={false}
        showNumber={false}

      />
      {
        fastagRechargeOpen && <RechargeFastagSideBar
          rightSideBarOpen={fastagRechargeOpen}
          defaultData={fastagDefaultData}
          sideBarTitle={'Recharge FASTag'}
          handleSubmit={event => { }}
          toggleRightSideBar={handleFastagRechargeClose}
        ><div></div></RechargeFastagSideBar>
      }
      {addDriverModalOpen && <AddDialog open={addDriverModalOpen} onClose={handleAddDriverModalClose} type={'driver'} onConfirm={handleOnConfirm} fromDriver={true} />}
      {driverNameModalOpen && <DriverNameSelect onOpen={driverNameModalOpen} onClose={handleDriverGaveModelClose} type={type} />}
      {addPartyOpen && <AddParty open={addPartyOpen} onClose={handleAddPartyModalClose} onSave={handlePartySave} />}
      {addShopOpen && <AddShop open={addShopOpen} onClose={handleAddShopModalClose} onSave={handleShopSave} />}
      {editShopDialogOpen && <AddShop open={editShopDialogOpen} onClose={handleEditShopClose} onSave={handleShopSaveEdit} defaultId={location.state && location.state.shopId ? location.state.shopId : ""} defaultName={location.state && location.state.shopName ? location.state.shopName : ""} defaultNumber={location.state && location.state.shopNumber ? location.state.shopNumber : ""} />}
      {/* {addPartyOpen && <AccountDetailsDialog open={addPartyOpen} onClose={handleAddPartyModalClose} />} */}
      {dialogGaveAndGot && <DriverGaveAndGot balanceType={type} onClose={handleBalanceClose} onOpen={dialogGaveAndGot} driverId={location.state && location.state.driverId ? location.state.driverId : ""} onConfirm={handleConfirm} fromSingleDriver={true} />}
      {dialogShopCreditPayment && <ShopCreditAndPayment balanceType={type} onClose={handleShopCreditPaymetClose} onOpen={dialogShopCreditPayment} shopId={location.state && location.state.shopId ? location.state.shopId : ""} onConfirm={handleShopCreditPaymentConfirm} fromSingleShop={true} />}
      {/* {editProfileModal && <EditProfileDialog onClose={handleEditProfileDialogClose} open={editProfileModal} />} */}
      {deleteTripOpen && <DeleteTripJourney deleteOpen={deleteTripOpen} tripId={tripId} onDeleteSucees={onTripDeleteSucees} onDeleteNo={onTripDeleteNo} />}
      {editProfileModal && <EditProfileDialog onClose={handleEditProfileDialogClose} onOpen={editProfileModal} onConfirm={handleEditProfileDialogOnConfirm} />}
      {addEditTripSideBarOpen && <AddEditTripSideBar sideBarTitle="Edit Trip" sideBarOpen={addEditTripSideBarOpen} sideBarClose={handleAddEditTripSideBarClose} tripId={tripId} />}
      {/* {addPartyPaymentOpen && <AddPartyPayment sideBarTitle="Add Party Payment" sideBarOpen={addPartyPaymentOpen} sideBarClose={handleAddPartyPaymentClose} onSave={handleAddPartyPaymentSave} />} */}
      {addTripSideBarOpen && <AddEditTripSideBar sideBarTitle="Add Trip" sideBarOpen={addTripSideBarOpen} sideBarClose={handleAddTripSideBarClose} tripId={null} vehicleDataFromSingleTruck={singleTruckData ? singleTruckData : null} partyFromSingleParty={singlePartyData} supplierDataFromSingleVehicle={singleTruckData && singleTruckData.vendor ? singleTruckData.vendor : null} />}
      {editPartyDialogOpen && <AddParty open={editPartyDialogOpen} defaultId={(location.state && location.state.partyId) ? location.state.partyId : ""} defaultName={(location.state && location.state.pageTitle) ? location.state.pageTitle : ""} defaultNumber={user.partyMobile} onClose={handleEditPartyModalClose} onSave={handleEditPartySave} />}
      {deletePartyDialogOpen && <DeletePartyDialog open={deletePartyDialogOpen} onConfirm={handleDeletePartyConfirm} partyId={(location.state && location.state.partyId) ? location.state.partyId : ""} onClose={handleDeletePartyClose} />}
      {addSupplier && <AddSupplier open={addSupplier} onClose={handleAddSupplierClose} onSave={handleSupplierSave} />}
      {editSupplierDialogOpen && <AddSupplier open={editSupplierDialogOpen} onClose={handleEditSupplierClose} onSave={handleSupplierSaveEdit} defaultId={location.state && location.state.vendorId ? location.state.vendorId : ""} defaultName={supplierName} defaultNumber={supplierNumber} />}
      {deleteSupplierDialogOpen && <DeleteSupplierDialog open={deleteSupplierDialogOpen} onClose={handleDeleteSupplierDialogClose} onConfirm={handleDeleteSupplierConfirm} vendorId={location.state && location.state.vendorId ? location.state.vendorId : ""} />}
      {deleteShopDialogOpen && <DeleteShopDialog open={deleteShopDialogOpen} onClose={handleDeleteShopDialogClose} onConfirm={handleDeleteShopConfirm} shopId={location.state && location.state.shopId ? location.state.shopId : ""} />}
      {addVehicleOpen && <AddVehicle open={addVehicleOpen} fasTag={location && location.pathname && location.pathname.includes("/fastag") ? true : false} onClose={handleAddVehicleClose} onSave={handleVehicleSave} />}
      {comingSoonModal && <ComingSoonModal open={comingSoonModal} featureName={featureNameValue} onClose={handleComingSoonModalClose} />}
      {completeTripOpen && <TripCompleteActionDialog tripId={singleTruckData && singleTruckData.tripId ? singleTruckData.tripId : ""} open={completeTripOpen} onClose={handleTripCompleteActionClose} onSave={handleTripCompleteActionConfirm} />}
      {addExpenseDialog && <AddExpenseSelectionDialog open={addExpenseDialog} onClose={handleCloseAddExpense} />}
      {multiUserAddOpen && <MuiltiUserAddUserDialog open={multiUserAddOpen} onClose={handleMultiUserAddClose} onSave={handleMultiUserAddSave} />}
      {inviteSuccess && <MultiUserInviteSuccess open={inviteSuccess} userData={addUserInfo} onClose={handleMultiUserInviteSuccessClose} />}
      {addSupplierPayment && <AddPaymentSingleSupplier open={addSupplierPayment} supplierNameValue={user && user.singleVendorPageName ? user.singleVendorPageName : ""} onClose={handleSingleSupplierPaymentClose} onConfirm={handleSingleSupplierPaymentConfirm} />}
      {addPartyPaymentOpen && <AddPaymentSingleParty partyName={location && location.state && location.state.pageTitle ? location.state.pageTitle : ""} open={addPartyPaymentOpen} onClose={handleAddPartyPaymentClose} onConfirm={handleAddPartyPaymentSave} />}
      {addInvoiceFlag && <AddInvoiceSideBar rightSideBarOpen={addInvoiceFlag} onClose={handleAddInvoiceClose} onConfirm={handleAddInvoiceConfirm} />}
      {invoiceDeleteOpen && <DeleteInvoiceDialog open={invoiceDeleteOpen} onClose={handleDeleteInvoiceClose} onConfirm={handleDeleteInvoiceConfirm} invoiceId={location && location.state && location.state.invoiceId ? location.state.invoiceId : currentId} />}
      {singleInvoicePdf && <ReportsDialog name={"Invoice Preview"} open={singleInvoicePdf} onClose={handleSingleInvoicePdfClose} invoiceId={location && location.state && location.state.invoiceId ? location.state.invoiceId : currentId} />}
      {invoiceAddPayment && <InvoiceAddPaymentSideBar open={invoiceAddPayment} onClose={handleInvoiceAddPaymentClose} onConfirm={handleInvoiceAddPaymentConfirm} />}
      {editDriverDialog && <EditDriverDialog open={editDriverDialog} onClose={handleEditDriverClose} onConfirm={handleEditDriverConfirm} driverData={singleDriverData} />}
      {
        editPartyBalanceOpen && <AddEditOpeningBalanceParty
          open={editPartyBalanceOpen}
          onClose={handleEditOpeningBalanceClose}
          onSave={handleEditOpeningBalanceClose}
          defaultId={parties && parties.details && parties.details.openingBalance && parties.details.openingBalance.id ? parties.details.openingBalance.id : null}
          defaultOpeningBalance={parties && parties.details && parties.details.openingBalance && parties.details.openingBalance.amount ? parties.details.openingBalance.amount : null}
          defaultOpeningBalanceDate={parties && parties.details && parties.details.openingBalance && parties.details.openingBalance.date ? parties.details.openingBalance.date : null}
          startOpeningBalanceDate={parties && parties.details && parties.details.defaultOpeningBalanceDate ? parties.details.defaultOpeningBalanceDate : null}
        />
      }
      {
        addPartyBalanceOpen && <AddEditOpeningBalanceParty
          open={addPartyBalanceOpen}
          onClose={handleAddOpeningBalanceClose}
          onSave={handleAddOpeningBalanceClose}
          startOpeningBalanceDate={parties && parties.details && parties.details.defaultOpeningBalanceDate ? parties.details.defaultOpeningBalanceDate : null}
        />
      }
      {
        editLoadSideBar && <EditLoadDetailsSideBar
          rightSideBarOpen={editLoadSideBar}
          sideBarTitle={'Edit Trip'}
          data={null}
          cStyle={true}
          onEdit={null}
          onDelete={null}
          fetchJourney={() => { fetchTrip(tripId) }}
          //sideBarSecondaryTitle={null}
          handleSubmit={event => { }}
          toggleRightSideBar={handleEditLoadClose}
        >
        </EditLoadDetailsSideBar>
      }
      {/* ****************************************************** Pop Ups ******************************************************. */}
      {supplierPassbookPopUpOpen && <SupplierPassbookPopUp open={supplierPassbookPopUpOpen} onClose={handleSupplierPassbookPopUpClose} onAddSupplierPayment={addSupplierPaymentPopUp} />}

      {/* ****************************Diesel Card Recharge sidebar **************************** */}
      {dieselCardRechargeSideBarOpen && <DieselCardRechargeSideBar rightSideBarOpen={dieselCardRechargeSideBarOpen} onClose={handleDieselCardRechargeSideBarClose} truckInfo={dieselCardTruckDetails} redirectTo={handleDieselCardRedirection} />}
    </>
  );
};
Header.prototypes = {
  logo: PropTypes.string,
  logoAltText: PropTypes.string
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchGetSingleFastagVehicleDetails: (id, onSuccess, onFailure) => {
    dispatch(getSingleFastTagDetails(id, onSuccess, onFailure));
  },
  dispatchGetPartyLedgerAction: (requestData) =>
    dispatch(
      getPartyLedgerData(
        requestData,
        () => {
          logger.log("Party Ledger", "Party Ledger Data Loading Success");
        },
        () => {
          logger.log("Party Ledger", "Party Ledger Data Loading Failure");
        }
      )
    ),

  dispatchGetSingleDriver: (id, data, onSuccess, onFailure) => {
    dispatch(fetchSingleDriver(id, data, onSuccess, onFailure));
  },
  dispatchDeleteDriver: (id, onSuccess, onFailure) => {
    dispatch(deleteDriver(id, onSuccess, onFailure))
  },
  dispatchEditDriver: (id, data, onSuccess, onFailure) => {
    dispatch(editDriver(id, data, onSuccess, onFailure))
  },
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getJourneyDetails(tripId, onSuccess, onError)),
  dispatchFetchUserDetails: (onSuccess, onFailure) => {
    dispatch(getUserDetails(onSuccess, onFailure))
  },
  dispatchGetVehicleLedgerAction: (requestData, onSuccess) => {
    dispatch(
      getVehicleLedgerData(
        requestData,
        () => {
          if (onSuccess) {
            onSuccess();
          }
          logger.log("Trucks Component", "Vehicles Ledger Data Loading Success");
        },
        () => {
          logger.log("Trucks Component", "Vehicles Ledger Data Loading Failure");
        }
      )
    )
  },
  dispatchGetTripLedgerAction: (requestData) =>
    dispatch(
      getTripLedgerDataV2(
        requestData,
        () => {
          logger.log("Trip Ledger", "Trip Ledger Data Loading Success");
        },
        () => {
          logger.log("Trip Ledger", "Trip Ledger Data Loading Failure");
        }
      )
    ),
  dispatchGetVendorLedgerAction: (requestData) =>
    dispatch(
      getVendorLedgerData(
        requestData,
        () => {
          logger.log("Header Dweb", "Party Ledger Data Loading Success");
        },
        () => {
          logger.log("Header Dweb", "Party Ledger Data Loading Failure");
        }
      )
    ),
  dispatchGetSingleVendorDetails: (id, onSuccess, onFailure) => {
    dispatch(singleVendorDetails(id, onSuccess, onFailure))
  },
  dispatchGetSingleTruck: (truckId, onSuccess, onFailure) => dispatch(singleTruck(truckId, onSuccess, onFailure)),
  dispatchGetPandL: (data, defaultDateFilterValue, onSuccess, onFailure) => dispatch(PandL(data, defaultDateFilterValue, onSuccess, onFailure)),
  dispatchGetTripExpenses: (data, defaultTripBookFilterValue, onSuccess, onFailure) => dispatch(Expenses(data, defaultTripBookFilterValue, onSuccess, onFailure)),
  dispatchGetSinglePartyTripSparkLine: (requestData, onSuccess, onFailure) => dispatch(getTripSparkLine(requestData, onSuccess, onFailure)),
  dispatchGetSinglePartyPayments: (requestData, onSuccess, onFailure) => dispatch(getPartyPayments(requestData, onSuccess, onFailure)),
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchGetSinglePartyLedgerAction: (requestData, onSuccess) =>
    dispatch(
      getSinglePartyLedgerDataV2(
        requestData,
        () => {
          if (onSuccess) {
            onSuccess();
          }
        },
        () => {
        }
      )
    ),
  dispatchGetSinglePartyMonthlyBalancesAction: (requestData, onSuccess, onError) =>
    dispatch(
      getMonthlyBalancesParty(
        requestData,
        onSuccess,
        onError
      )
    ),
  dispatchToggleTripOverlay: () => {
    dispatch(toggleOverlay(false))
  },
  dispatchGetMultiUserList: (onSuccess, onError) => {
    dispatch(getMultiUserList(onSuccess, onError))
  },
  dispatchFetchSupplierTransact: (transactData, onSuccess, onFailure) => {
    dispatch(fetchSupplierTransactionLog(transactData, onSuccess, onFailure))
  },
  dispatchGetSingleVendorLedger: (data, onSuccess, onFailure) => {
    dispatch(getSingleVendorLedgerData(data, onSuccess, onFailure))
  },
  dispatchEditInvoiceFlag: (editInvoiceFlag) => {
    dispatch(toggleEditInvoiceFlag(editInvoiceFlag))
  },
  dispatchGetSingleInvoice: (invoiceId, onSuccess, onError) => {
    dispatch(getSingleInvoice(invoiceId, onSuccess, onError))
  },
  dispatchGetSparklineBalances: (onSuccess, onFailure) => {
    dispatch(getSparklineTotalBalances(onSuccess, onFailure))
  },
  dispatchGetWalletBalance: (data, onSuccess, onError) => {
    dispatch(getWalletBalance(data, onSuccess, onError))
  },
  dispatchGetPartyDetails: (id, onSuccess, onFailure) => {
    dispatch(getPartyDetails(id, onSuccess, onFailure))
  },
});
const HeaderWithRouter = withRouter(Header);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderWithRouter);
